'use client';

import { DeviceName } from 'types/models';
import { ArmGripperVelocity } from 'types/models/arm-control/ArmControl';

import { HUB_URL } from './const';
import { useSignalRHub } from './context/useSignalRHub';

export enum TeleoperationHubEvents {
  // todo - move to ros bridge
  SEND_TELEOPERATION_MOVEMENT_DATA = 'SendTeleoperationMovementData', // invoke
  // todo - move to ros bridge
  SEND_PAYLOAD_GIMBAL_DATA = 'SendPayloadGimbalMovementData',
  // todo - move to ros bridge
  SEND_ARM_GRIPPER_VELOCITY = 'SendArmGripperVelocity', // invoke
  // Controls
  RECEIVE_CONTROL_PERMISSION_REQUEST = 'ReceiveControlPermissionRequest', // listen
  RECEIVE_CONTROL_PERMISSION_RESPONSE = 'ReceiveControlPermissionResponse', // listen
  RECEIVE_NEWLY_SET_MAIN_OPERATOR = 'ReceiveNewlySetMainOperator', // listen
}

/**
 * For bedder understanding image a plane or a drone and then
 * - x: current flight direction - moving around this axis like rolling
 * - y: left/right direction - moving around this axis is like looking up/down
 * - z: top/down direction - moving around this axis is like looking left/right
 */
export type Rotation = {
  /**
   * role - x
   */
  rX: number;
  /**
   * pitch
   */
  sY: number;
  /**
   * yaw - used for "looking" left or right, e.g. with Q/E on robot but like
   */
  tZ: number;
};

export type Translation = {
  /**
   * back/forward
   */
  x: number;
  /**
   * Left or right
   */
  y: number;
  /**
   * properly height
   */
  z: number;
};

export type Movement = {
  velocityScaling: number;
  rotation: Rotation;
  translation: Translation;
};

export type TeleoperationMovementDTO = {
  deviceName: DeviceName;
  movement: Movement;
};

export type TeleoperationArmVelocityDTO = {
  deviceName: DeviceName;
  armGripperVelocity: ArmGripperVelocity;
};

export type TeleoperationPayloadGimbalDataDTO = {
  deviceName: string;
  Roll?: number;
  Pitch?: number;
  Yaw?: number;
};

/**
 * Hook to use for the Teleportation hub
 *
 * @deprecated Please move everything to ros bridge!
 */
export function useTeleoperationHub() {
  const hub = useSignalRHub(HUB_URL.TELEOPERATION);

  async function sendArmGripperVelocity(data: TeleoperationArmVelocityDTO) {
    return hub.invoke(TeleoperationHubEvents.SEND_ARM_GRIPPER_VELOCITY, data);
  }

  async function sendTeleoperationMovementData(data: TeleoperationMovementDTO) {
    return hub.invoke(TeleoperationHubEvents.SEND_TELEOPERATION_MOVEMENT_DATA, data);
  }

  async function sendPayloadGimbalMovementData(data: TeleoperationPayloadGimbalDataDTO) {
    return hub.invoke(TeleoperationHubEvents.SEND_PAYLOAD_GIMBAL_DATA, data);
  }

  const TeleoperationHubClient = {
    sendArmGripperVelocity,
    sendTeleoperationMovementData,
    sendPayloadGimbalMovementData,
  };

  return { ...hub, TeleoperationHubClient };
}
